import React from "react";
import { Container, Row, Col } from "shards-react";
import MainSidebar from "./MainSidebar/MainSidebar";
import MainNavbar from "./MainNavbar/MainNavbar";

export default class DefaultLayout extends React.Component {

    setAuth() {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            this.props.auth.login();
        }

        const jwtToken = this.props.auth.parseJwt(token);
        const hasPartnerToken = jwtToken.username !== undefined && jwtToken.username.includes('partner');

        const hasAuth0Token = this.props.auth.accessToken
            && this.props.auth.idToken
            && this.props.auth.expiresAt;

        if (hasPartnerToken && (jwtToken.exp * 1000) < Date.now()) {
           this.props.auth.logout();
        }

        if (!hasAuth0Token && !hasPartnerToken) {
            if (!this.props.auth.checkExistSession()) {
                this.props.auth.login();
            }
        }

        const isAuthenticatedAuth0 = this.props.auth.isAuthenticated();
        if (!isAuthenticatedAuth0 && !hasPartnerToken) {
            this.props.auth.login();
        }
    }

    componentWillMount() {
        this.setAuth();
    }

    render() {
      return (
        <Container fluid>

          <Row>
            <MainSidebar match={this.props.match}/>
            <Col
                className="main-content p-0"
                lg={{size: 10, offset: 2}}
                md={{size: 9, offset: 3}}
                sm="12"
                tag="main"
            >
                <MainNavbar auth={this.props.auth}/>
              { this.props.children }
            </Col>
          </Row>
        </Container>
      );
    }

}


// WEBPACK FOOTER //
// ./src/layouts/Default.js